// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom'
import 'react-folder-tree/dist/style.css';
// COMPONENTS
// CUSTOM COMPONENTS
import * as alert from "../../../../redux/alertSnackBarRedux";
import RecursiveTreeComponent from '../../../components/RecursiveTreeComponent';
// SERVICES AND HELPERS
import * as jobDocumentService from "../../../../services/service/jobDocumentService";
import * as helper from '../../../../helpers/helper';

const JobDocumentPage = (props) => {
    const { showAlert } = props;
    const { jobId } = useParams();

    useEffect(() => {
        fetchJobDocuments();
    }, []);

    const fetchJobDocuments = () => {
        jobDocumentService.getJobDocuments(jobId).then(res => {
            setFolderStructure(res)
        })
    }

    const [folderStructure, setFolderStructure] = useState({
        id: 99999,
        name: 'Documents',
        filePath: null,
        children: null
    });

    const addNewFileFolder = (jobDoc) => jobDocumentService.saveJobDocument(helper.convertJsonToFormData({ ...jobDoc, jobId: jobDoc.parentId ? null : jobId })).then(res => {
        showAlert({ message: res.message, variant: 'success' });

        return res.jobDocument
    }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))

    const renameFileFolder = (id, name) => jobDocumentService.renameJobDocument(id, name).then(res => {
        showAlert({ message: res.message, variant: 'success' });
    }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))

    const deleteFileFolder = (id) => jobDocumentService.deleteJobDocument(id).then(res => {
        showAlert({ message: res.message, variant: 'success' });
    }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))

    return (
        <div className="row" >
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Job Documents
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Documents
                            </span>
                        </h3>
                    </div>
                    <div className="container mb-10">
                        <RecursiveTreeComponent
                            folderStructure={folderStructure}
                            setFolderStructure={setFolderStructure}
                            addNewFileFolder={addNewFileFolder}
                            renameFileFolder={renameFileFolder}
                            deleteFileFolder={deleteFileFolder}
                        />
                    </div>
                </div>
            </div>
        </div >
    );
}

export default connect(null, alert.actions)(JobDocumentPage);